import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { SecurityService } from './../../services/security.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  appVersion = environment.appVersion;
  loginForm: FormGroup;
  error;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private spinner: NgxSpinnerService,
    private securityService: SecurityService,
    private fireAuth: AngularFireAuth
  ) {}

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      login: ['', [Validators.email, Validators.required]],
      password: ['', Validators.required],
    });
  }

  async submit() {
    if (this.loginForm.valid) {
      this.spinner.show();
      try {
        localStorage.removeItem('currentUser');
        this.securityService.currentUserSubject.next(null);
        await this.securityService.makeLogin(
          this.loginForm.get('login').value,
          this.loginForm.get('password').value
        );
        this.router.navigateByUrl('/');
        this.spinner.hide();
      } catch (err) {
        this.error = err.message;
        console.log(err);
        this.spinner.hide();
      }
    } else {
      this.error = 'Favor preencher os campos';
    }
  }
}
